export default "__VITE_ASSET__Dzdm053w__"